import React from 'react';
import Navbar from '../components/layout/Navbar';
import AddEmailForm from '../components/layout/AddEmailForm';

function AddEmailPage() {
  return (
    <div>
      <Navbar />
      <div className='container'>
        <br />
        <h2>Add an Email</h2>
        <AddEmailForm />
      </div>
    </div>
  );
}

export default AddEmailPage;
